import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetBclProductDetailResponseDto } from "../../dtos/bcl-product-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetBclProductDetailQueryProps = {
  productId: string;
  options?: Omit<UseQueryOptions<GetBclProductDetailResponseDto>, "queryKey">;
};

export const useGetBclProductDetailQuery = ({
  productId,
  options
}: UseGetBclProductDetailQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getBclProductDetail({ productId }).queryKey,
    queryFn: async () =>
      await ProductService.getBclProductDetail({
        payload: { productId }
      }),
    ...options
  });
};
